import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

/////////////////////////// Custom code

/*document.addEventListener('click', function(e) {
  const btn = e.target.closest('#checkout');
  if (btn) {
    console.log("test");
  }

 if (btn) {
    //e.preventDefault();   // 🔥 IMPORTANT
    //e.stopPropagation();  // 🔥 prevents theme JS conflict

    window.location.href = '/checkout';
  }

}); */

/*document.addEventListener('click', function (e) {
  const btn = e.target.closest('#checkout');

  if (btn) {
  e.preventDefault(); 
    console.log("checkout clicked");

    const dialog = document.querySelector('.cart-drawer__dialog');

    if (dialog && typeof dialog.close === 'function') {
      dialog.close();
    }
  }
}); */

/*document.addEventListener('click', function (e) {
  const btn = e.target.closest('#checkout');

  if (btn) {
    e.preventDefault(); 
    console.log("checkout clicked");

    setTimeout(() => {
      const deliverySection = document.querySelector('.checkout-body-wrap');

      if (deliverySection) {
        const dialog = document.querySelector('.cart-drawer__dialog');

        if (dialog && typeof dialog.close === 'function') {
          dialog.close();
        }
      }
    }, 2000); // adjust if needed
  }
}); */
